import _ from "lodash";
import { lastValueFrom } from "rxjs";
import { BackendApiService } from "src/app/core/services/backend-api";
import { DropDownOptions, IBudgetAllocForm, IItemToRequest } from "src/app/shared/models/app-models";
import { BudgetAllocationSummary, GeneralForm, MyPurchaseForm } from "src/app/shared/models/app-models/MyPurchaseForm.model";
import { totalAmountCalculation, totalAORExemptedAmountCalculation,budgetInformation } from "src/app/modules/shared/utils/return-budget-calculation";

export const getOperatingBudgetAllocations = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort()
    let budgetCount = 0
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter(
            (s) => s.BudgetType.value === 'Operating' && !s.isDeleted
        ),
        (allo) =>
            (allo.CostCentre?.value ?? '') +
            (allo.OrderNo?.value ?? '') +
            (allo.BudgetExpenditureUsage?.value ?? '') +
            (allo.BudgetFrequencyUsage?.value ?? '') + allo.Strikethrough
    );

    let result = _.map(budgetGroup, (allocation, key) => {
        console.log('test')
        let totalAmount = totalAmountCalculation(allocation, itemList);
        let totalAORExemptedAmount = totalAORExemptedAmountCalculation(allocation, itemList);
        
        budgetCount++;
        const glAccountString = allocation
            .map(allo => allo.GLAcc?.value)
            .filter((value, index, self) => self.indexOf(value) === index).
            join(', ');

        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedPurchaseItemNo = allocation.map(allo => allo.displayPurchaseItemNumber).join(', ');

        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            costCentre: allocation[0].CostCentre?.value ?? '',
            glAccount: glAccountString,
            orderNo: allocation[0].OrderNo?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            reccurent: allocation[0].BudgetExpenditureUsage?.value === 'Budgeted' ? allocation[0].BudgetFrequencyUsage?.value ?? '' : "NA",
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: purchaseItemNo,
            projectBudget: '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            fundCentre: '',
            budgetId: budgetCount.toString(),
            projectCode: '',
            aorExemptedAmount: Math.round(totalAORExemptedAmount * 100) / 100,
            aorAmount: Math.round((totalAmount - totalAORExemptedAmount) * 100) / 100,
            personnel: '',
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedPurchaseItemNo
        } as BudgetAllocationSummary;
    });
    return result;
}
export const getTotalBudgetCost = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): number => {
    let totalAmount = allBudgetAllocationForms.reduce((sum, allo, i) => {
        let item = itemList.find(x => x.AddItems.itemId == allo.PurchaseItemNo as number);
        if (!item) return sum;

        if (allo.Quantity) {
            return (
                sum +
                (allo.Quantity * item.ItemPrice.UnitPrice) /
                item.ItemPrice.UnitsPerQuantity
            );
        } else {
            console.log(
                'check',
                allo.Percentage,
                item.ItemPrice.UnitPrice,
                item.ItemPrice.Quantity,
                item.ItemPrice.UnitsPerQuantity
            );
            return (
                sum +
                ((allo.Percentage ?? 1) *
                    ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) /
                        item.ItemPrice.UnitsPerQuantity)) /
                100
            );
        }
    }, 0);
    return totalAmount
}
export const checkIfProjectRORequired = (
    allBudgetAllocationForms: IBudgetAllocForm[], itemlist: IItemToRequest[], includePersonnelCriteria:boolean
): boolean => {
    let itemIdList = itemlist.filter(x => !x.isDeleted && !x.Strikethrough).map(x => x.AddItems.itemId).sort()
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter((s) => s.BudgetType.value === 'Project' && !s.isDeleted && !s.Strikethrough),
        (allo) =>
            (allo.ProjectCode?.id ?? '') +
            (allo.ProjectBudget?.id ?? '')
    )
    let result:BudgetAllocationSummary[] = _.map(budgetGroup, (allocation, key) => {
        let totalAmount = totalAmountCalculation(allocation, itemlist);
        let approvingPersonnels = [{ id: allocation[0].ApprovingOfficer, value: allocation[0].ApprovingOfficer } as DropDownOptions];
        const glAccountString = allocation
            .map(allo => allo.GLAcc?.value)
            .filter((value, index, self) => self.indexOf(value) === index).
            join(', ');
        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedPurchaseItemNo = allocation.map(allo => allo.displayPurchaseItemNumber).join(', ');

        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            glAccount: glAccountString,
            id: purchaseItemNo,
            projectBudget: allocation[0].ProjectBudget?.value ?? '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            projectCode: allocation[0].ProjectCode?.id ?? '',
            costCentre: '',
            orderNo: '',
            budgeted: '',
            reccurent: '',
            percentage: 0,
            fundCentre: '',
            budgetId: '',
            aorExemptedAmount: 0,
            aorAmount: Math.round(totalAmount * 100) / 100,
            personnel: allocation[0].ApprovingOfficer
                ? approvingPersonnels.find(
                    (person) => person.id == allocation[0].ApprovingOfficer
                )
                : '',
            personnelOptions: approvingPersonnels,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedPurchaseItemNo
        };
    });
    let isProjectRORequired = false
    if (includePersonnelCriteria) {
        result.forEach(x => {
            if (x.totalAmount > 6000 && !x.personnel)
                isProjectRORequired = true
        })
        return isProjectRORequired;
    }
    else {
        result.forEach(x => {
            if (x.totalAmount > 6000)
                isProjectRORequired = true
        })
        return isProjectRORequired;
    }
}

export const getProjectBudgetAllocations = (
    allBudgetAllocationForms: IBudgetAllocForm[], itemlist: IItemToRequest[], backendApi: BackendApiService, genForm: GeneralForm
): Promise<BudgetAllocationSummary>[] => {
    let itemIdList = itemlist.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort()
    let budgetGroup = _.groupBy(
        allBudgetAllocationForms.filter((s) => s.BudgetType.value === 'Project' && s.ProjectCode?.id && s.ProjectBudget?.id && !s.isDeleted),
        (allo) =>
            (allo.ProjectCode?.id ?? '') +
            (allo.ProjectBudget?.id ?? '') + allo.Strikethrough
    )
    let groupOnlyByProjectCode = _.groupBy(
        allBudgetAllocationForms.filter((s) => s.BudgetType.value === 'Project' && s.ProjectCode?.id && s.ProjectBudget?.id && !s.isDeleted && !s.Strikethrough),
        (allo) =>
            (allo.ProjectCode?.id ?? '')
    );
    const codeTotals: { [key: string]: number } = {};
    Object.keys(groupOnlyByProjectCode).forEach(allocation => {
        let totalAmount = totalAmountCalculation(groupOnlyByProjectCode[allocation], itemlist);
        codeTotals[allocation] = totalAmount;
    });
    let result = _.map(budgetGroup, async (allocation, key) => {

        let totalAmount = totalAmountCalculation(allocation, itemlist);
        let approvingPersonnels = await getApprovingPersonnelOptions(
            allocation[0],
            codeTotals[allocation[0]?.ProjectCode?.id ?? ''],
            allocation.map((allo) => allo.PurchaseItemNo).join(','), backendApi, genForm
        );
        const glAccountString = allocation
            .map(allo => allo.GLAcc?.value)
            .filter((value, index, self) => self.indexOf(value) === index).
            join(', ');
        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedPurchaseItemNo = allocation.map(allo => allo.displayPurchaseItemNumber).join(', ');

        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            glAccount: glAccountString,
            id: purchaseItemNo,
            projectBudget: allocation[0].ProjectBudget?.value ?? '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            projectCode: allocation[0].ProjectCode?.id ?? '',
            costCentre: '',
            orderNo: '',
            budgeted: '',
            reccurent: '',
            percentage: 0,
            fundCentre: '',
            budgetId: '',
            aorExemptedAmount: 0,
            aorAmount: Math.round(totalAmount * 100) / 100,
            personnel: allocation[0].ApprovingOfficer
                ? approvingPersonnels.find(
                    (person) => person.id == allocation[0].ApprovingOfficer
                )
                : '',
            personnelOptions: approvingPersonnels,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedPurchaseItemNo,
            wbsElement: allocation[0].ProjectBudget?.id ?? ''
        };
    });
    return result;
}


export const getApprovingPersonnelOptions = async (
    budget: IBudgetAllocForm,
    totalAmount: number,
    itemNo: String, backendApi: BackendApiService, genForm: GeneralForm
): Promise<DropDownOptions[]> => {
    if (!budget.ProjectCode || budget.ProjectCode && budget.ProjectCode.id.length == 0) throw new Error('Invalid Project Code')
    if (!budget.ProjectBudget || budget.ProjectBudget && budget.ProjectBudget.id.length == 0) throw new Error('Invalid Project Budget')
    let ao = await lastValueFrom(
        backendApi.getProjectBudgetApprovingPersonnel(
            budget.ProjectCode?.id as string,
            budget.ProjectBudget?.id as string,
            totalAmount?.toString()
        )
    );
    console.log('ao from api', ao);
    let options = ao?.AOList.map((s) => ({
        id: s.ActiveDirectoryId,
        value: s.DisplayName,
        item: itemNo,
        budget: {
            id: budget.ProjectCode?.id,
            budgetCode: budget.ProjectBudget?.id,
            glAccount: budget.GLAcc?.id,
        }
    }));
    options = options.filter(
        (user) =>
            user.id.trim().toLocaleLowerCase() !==
            genForm.RO.id.trim().toLocaleLowerCase()
    );
    return options;
}

export const calculateFinancialYear = (PlannedDeliveryDate:Date) : any => {
    
    const deliveryDate = new Date(PlannedDeliveryDate);

    const deliveryYear = deliveryDate.getFullYear();
    const deliveryMonth = deliveryDate.getMonth();

    const FYStart = deliveryMonth >= 3 ? new Date(deliveryYear, 3, 1) : new Date(deliveryYear - 1, 3, 1);
    const FYEnd = deliveryMonth >= 3 ? new Date(deliveryYear + 1, 2, 31) : new Date(deliveryYear, 2, 31);

    if (deliveryDate >= FYStart && deliveryDate <= FYEnd) {
        return {
            "FYStart" : FYStart.getFullYear(),
            "FYEnd"   : FYEnd.getFullYear()
        };
    }  else{
        return '';
    } 
}
export const getOperatingBudgetAllocationsCWithFinancialYear = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort()
    let ballocation: any[] = budgetInformation(allBudgetAllocationForms, itemList);
    let budgetCount = 0
    let budgetGroup = _.groupBy(
        ballocation.filter(
            (s) => s.BudgetType.value === 'Operating' && !s.isDeleted
        ),
        (allo) =>
            (allo.CostCentre?.value ?? '') +
            (allo.OrderNo?.value ?? '') +
            (allo.BudgetExpenditureUsage?.value ?? '') +
            (allo.BudgetFrequencyUsage?.value ?? '') + allo.Strikethrough + allo.FinancialYear
    );
    let result = _.map(budgetGroup, (allocation, key) => {

        let totalAmount = totalAmountCalculation(allocation, itemList);
        let totalAORExemptedAmount = totalAORExemptedAmountCalculation(allocation, itemList);
        budgetCount++;
        const glAccountString = allocation
            .map(allo => allo.GLAcc?.value)
            .filter((value, index, self) => self.indexOf(value) === index).
            join(', ');

        const purchaseItemNo = allocation
            .map(allo => allo.PurchaseItemNo)
            .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
            .join(', ');
        const displayedPurchaseItemNo = allocation.map(allo => allo.displayPurchaseItemNumber).join(', ');
        return {
            budgetType: allocation[0].BudgetType?.value ?? '',
            costCentre: allocation[0].CostCentre?.value ?? '',
            glAccount: glAccountString,
            orderNo: allocation[0].OrderNo?.value ?? '',
            budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
            reccurent: allocation[0].BudgetFrequencyUsage?.value ?? '',
            percentage: allocation.reduce(
                (sum, allo) => sum + (allo.Percentage ?? 1),
                0
            ),
            id: purchaseItemNo,
            projectBudget: '',
            totalAmount: Math.round(totalAmount * 100) / 100,
            fundCentre: '',
            budgetId: budgetCount.toString(),
            projectCode: '',
            aorExemptedAmount: Math.round(totalAORExemptedAmount * 100) / 100,
            aorAmount: Math.round((totalAmount - totalAORExemptedAmount) * 100) / 100,
            personnel: '',
            personnelOptions: undefined,
            Strikethrough: allocation[0].Strikethrough,
            displayPurchaseItemNumber: displayedPurchaseItemNo,
            FinancialYear: allocation[0].FinancialYear,
            EndFinancialYear: allocation[0].EndFinancialYear
        } as BudgetAllocationSummary;
    });
    return result;
}


export const getCapitalBudgetAllocationsWithFinancialYear = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList.filter(x => !x.isDeleted).map(x => x.AddItems.itemId).sort((a, b) => a - b);
    let ballocation: any[] = budgetInformation(allBudgetAllocationForms, itemList);

    let budgetGroup = _.groupBy(
        ballocation.filter((s) => s.BudgetType.value === 'Capital' && !s.isDeleted),
        (allo) =>
        (allo.FundCentre?.value ?? '') +
        (allo.OrderNo?.value ?? '') +
        (allo.BudgetExpenditureUsage?.value ?? '') + (allo.Strikethrough) + allo.FinancialYear
    );
    
    let result = _.map(budgetGroup, (allocation, key) => {
        let totalAmount = totalAmountCalculation(allocation, itemList);
    
        const glAccountString = allocation
        .map(allo => allo.GLAcc?.value)
        .filter((value, index, self) => self.indexOf(value) === index).
        join(', ');
    
        const purchaseItemNo = allocation
        .map(allo => allo.PurchaseItemNo)
        .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
        .join(', ');
        const displayedPurchaseItemNo = allocation
        .map(allo => allo.displayPurchaseItemNumber).join(', ');
        return {
        budgetType: allocation[0].BudgetType?.value ?? '',
        costCentre: allocation[0].CostCentre?.value ?? '',
        glAccount: glAccountString,
        orderNo: allocation[0].OrderNo?.value ?? '',
        budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
        wbsElement: allocation[0].ProjectBudget?.id ?? '',
        reccurent: allocation[0].BudgetFrequencyUsage?.value ?? '',
        percentage: allocation.reduce(
            (sum, allo) => sum + (allo.Percentage ?? 1),
            0
        ),
        id: purchaseItemNo,
        projectBudget: '',
        totalAmount: Math.round(totalAmount * 100) / 100,
        fundCentre: allocation[0].FundCentre?.value ?? '',
        budgetId: '',
        projectCode: '',
        aorExemptedAmount: 0,
        aorAmount: Math.round(totalAmount * 100) / 100,
        personnel: '',
        personnelOptions: undefined,
        Strikethrough: allocation[0].Strikethrough,
        displayPurchaseItemNumber: displayedPurchaseItemNo,
        FinancialYear: allocation[0].FinancialYear,
        EndFinancialYear: allocation[0].EndFinancialYear
        };
    });
    
    return result;
}

export const getCapitalAUCAllocations = ( allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]): BudgetAllocationSummary[] => {
    let itemIdList = itemList
      .filter(x => !x.isDeleted)
      .map(x => x.AddItems.itemId)
      .sort((a, b) => a - b);
    let budgetGroup = _.groupBy(
      allBudgetAllocationForms.filter(
        (s) => s.BudgetType.value === 'Capital AUC' && !s.isDeleted
      ),
      (allo) =>
        (allo.BudgetExpenditureUsage?.value ?? '') +
        (allo.ProjectBudget?.id ?? '') + allo.Strikethrough
    );

    let result = _.map(budgetGroup, (allocation, key) => {

    let totalAmount = totalAmountCalculation(allocation, itemList);
    const glAccountString = allocation
    .map(allo => allo.GLAcc?.value)
    .filter((value, index, self) => self.indexOf(value) === index).
    join(', ');

    const purchaseItemNo = allocation
    .map(allo => allo.PurchaseItemNo)
    .filter((value, index, self) => self.indexOf(value) === index).map(x => itemIdList.indexOf(x!) + 1)
    .join(', ');
    const displayedItemNo = allocation
    .map(allo => allo.displayPurchaseItemNumber).join(', ');

    return {
        budgetType: allocation[0].BudgetType?.value ?? '',
        glAccount: glAccountString,
        budgeted: allocation[0].BudgetExpenditureUsage?.value ?? '',
        percentage: allocation.reduce(
            (sum, allo) => sum + (allo.Percentage ?? 1),
            0
        ),
        id: purchaseItemNo,
        totalAmount: Math.round(totalAmount * 100) / 100,
        projectBudget: allocation[0].ProjectBudget?.value ?? '',
        wbsElement: allocation[0].ProjectBudget?.id ?? '',
        fundCentre: '',
        costCentre: '',
        orderNo: '',
        reccurent: '',
        budgetId: '',
        projectCode: '',
        personnel: '',
        aorExemptedAmount: 0,
        aorAmount: 0,
        personnelOptions: undefined,
        Strikethrough: allocation[0].Strikethrough,
        displayPurchaseItemNumber: displayedItemNo
    };
    });

    return result;
}